import React from "react";
import { motion } from "framer-motion";
import { TrendingUp, AlertTriangle } from "lucide-react";

const DASH_IMG = "https://static.prod-images.emergentagent.com/jobs/6657fd82-3e2f-4bde-9317-9782f5512de1/images/05e9e0dd699202b6d0fe4e5761dd1cc866f3e1037ef706f62e04eb03b2fcbd15.png";

const TAGS = [
  "کارمزد نقد کردن: ۲۵٪",
  "تسویه با بالاترین نرخ ارز قابل پرداخت",
  "گزارش درآمد",
  "مناسب برای هنرمندان ایرانی",
];

export default function Royalty() {
  return (
    <section id="royalty" className="py-20 md:py-28 relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 items-center">
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-6"
          >
            <h2 className="mt-2 text-3xl md:text-4xl font-bold tracking-tight">
              درآمد موزیکت را بدون <span className="gradient-text-neon">دردسر</span> در ایران دریافت کن
            </h2>
            <p className="mt-5 text-slate-300 leading-relaxed">
              بعد از انتشار اثر، درآمد شما از پلتفرم‌های بین‌المللی بر اساس استریم، بازدید، کشور مخاطب،
              نوع پلتفرم و قوانین هر سرویس محاسبه می‌شود. ما درآمد دریافتی را مدیریت می‌کنیم و سهم شما را
              پس از کسر کارمزد ۲۵ درصد، با بالاترین نرخ ارز قابل پرداخت در ایران تسویه می‌کنیم.
            </p>

            <div className="mt-6 grid sm:grid-cols-2 gap-3">
              {TAGS.map((t, i) => (
                <div key={i} className="glass rounded-2xl px-4 py-3 flex items-center gap-3">
                  <TrendingUp className="w-4 h-4 text-cyan-300" />
                  <span className="text-sm text-slate-200">{t}</span>
                </div>
              ))}
            </div>

            <div className="mt-6 glass rounded-2xl p-4 flex items-start gap-3 border-amber-500/20">
              <AlertTriangle className="w-5 h-5 text-amber-300 shrink-0 mt-0.5" />
              <p className="text-sm text-slate-300 leading-relaxed">
                میزان درآمد نهایی قابل تضمین نیست و به عملکرد واقعی اثر در پلتفرم‌ها بستگی دارد.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-6 relative"
          >
            <div className="absolute -inset-10 bg-purple-600/20 blur-[120px] rounded-full pointer-events-none" />
            <div className="relative rounded-3xl overflow-hidden glass">
              <img src={DASH_IMG} alt="Royalty Dashboard" className="w-full h-auto" data-testid="royalty-dashboard-img" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#05050A]/60 to-transparent" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
